import { MARKUP_STRUCTURE } from '../../services/canonicalize/engine';

const shouldConvert = s => !(MARKUP_STRUCTURE.test(s) || /<p[^<]*>/.test(s));
const toRichText = s => '<p>' + s.replace(/\n\n/g, '</p><p><br></p><p>').replace(/\n/g, '</p><p>') + '</p>';

export default s => (shouldConvert(s) ? toRichText(s) : s);
